<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
@if (images(); as img) {
    <picture class="contents">
        <source [srcset]="img.mobile" media="(max-width: 767px)" />
        <source [srcset]="img.tablet" media="(min-width: 768px) and (max-width: 1023px)" />
        @if (img.desktop2xl) {
            <source [srcset]="img.desktop" media="(min-width: 1024px) and (max-width: 1535px)" />
            <source [srcset]="img.desktop2xl" media="(min-width: 1536px)" />
        } @else {
            <source [srcset]="img.desktop" media="(min-width: 1024px)" />
        }
        <img
            [ngClass]="[classList() ?? '', ignoreHeight() ? '' : 'h-auto', cover() ? 'object-cover' : '', 'max-w-full']"
            [loading]="priority() ? 'eager' : 'lazy'"
            [attr.fetchpriority]="priority() ? 'high' : 'low'"
            [width]="image().mobile.width"
            [height]="image().mobile.height"
            [src]="img.desktop"
            [alt]="alt()"
            (error)="onError.emit()"
        />
    </picture>
}
